import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { AgilentOktaAuthService } from '@app/agilent-okta-auth.service';
import { CognitoAuthService } from '@app/cognito-auth.service';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private router: Router,
        private agilentOktaAuth: AgilentOktaAuthService,
        private cognitoAuthService: CognitoAuthService
    ) {
        //
    }

    public isCognito() {
        return (environment.authentication_mode === 'cognito');
    }

    public isOkta() {
        return (environment.authentication_mode === 'okta');
    }

    public async getAuthorizationHeader() {
        if (this.isCognito()) {
            return this.cognitoAuthService.getIdToken();
        }
        if (this.isOkta()) {
            const accessToken = await this.agilentOktaAuth.getAccessToken();
            if (accessToken !== undefined) {
                return `Bearer ${accessToken}`;
            }
        }
    }

    public async logOut(isTimeout: boolean = false) {
        this.logEventAndLogOut(isTimeout);
    }

    public async refreshAuthToken() {
        if (this.isCognito()) {
            return await this.cognitoAuthService.refreshAuthToken();
        }
        if (this.isOkta()) {
            return await this.agilentOktaAuth.refreshAuthToken();
        }
    }

    public async logEventAndLogOut(isTimeout: boolean) {
        try {
            const token = await this.getAuthorizationHeader();
            const baseUrl = environment.api_base_url;
            const urlPart = `/activity-log/log-user-logout`;
            const url = `${baseUrl}${urlPart}`;
            const headers = {
                'Authorization': token,
                'Content-Type': 'application/json'
            };
            const body = {
                is_timeout: isTimeout
            };
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                credentials: 'include'
            });

            if (!response.ok) {
                throw Error();
            }
        }
        catch (ex) {
            console.log('ERROR logging logout event');
        }
        finally {
            if (this.isCognito()) {
                this.cognitoAuthService.logOut();
            }
            if (this.isOkta()) {
                this.agilentOktaAuth.logout();
            }
        }
    }

    public async attemptLogUserUnloadEvent() {
        // Attempt to call API to log the "unload" event time.
        // NOTE: on window/tab close, we can't guarantee that this
        // will be executed!
        try {
            const token = await this.getAuthorizationHeader();
            const baseUrl = environment.api_base_url;
            const urlPart = `/users/log-user-unload-event`;
            const url = `${baseUrl}${urlPart}`;
            const headers = {
                'Authorization': token,
            };
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                keepalive: true,
                credentials: 'include'
            });

            if (!response.ok) {
                throw Error();
            }
        }
        catch (ex) {
            console.log('ERROR logging unload event');
        }
    }

    public getGetCognitoAuthToken() {
        return this.cognitoAuthService.getIdToken();
    }
}
